import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase"
import { styled } from "styled-components"
import { TextDiv, TextSpan } from "../common/Text"
import { StyledButton } from "../common/Buttons"
import QuizItemSample from "./QuizItemSample"
import { useEffect } from "react"
import { useCookies } from "react-cookie"
import quizPreinfoState from "../../recoil/quizPreinfo"
import { isLoggedInState } from "../../recoil/auth/atom"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const QuizIntro = () => {
  const setQuizPhase = useSetRecoilState(quizPhaseState)
  const [, , removeCookie] = useCookies(["quizRound", "quizSessionId"])
  const resetQuizPreinfo = useResetRecoilState(quizPreinfoState)
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const navigate = useNavigate()

  useEffect(() => {
    removeCookie("quizRound")
    removeCookie("quizSessionId")
    resetQuizPreinfo()
  }, [removeCookie, resetQuizPreinfo])

  useEffect(() => {
    if (!isLoggedIn) {
      toast.error("로그인이 필요한 서비스입니다.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
      navigate("/user/login")
    }
  }, [isLoggedIn, navigate])

  return (
    <>
      <DescriptionDiv>
        <TextDiv fontSize={24} fontWeight="bold">
          검사 안내
        </TextDiv>
        <TextDiv $align="start" fontSize={15}>
          {
            "학문적성전공검사(college major aptitude test)는 학문프로파일에 기반하여 피험자의 전공적성을 진단해주는 도구입니다. 검사를 통해 자신의 적성에 맞는 학과를 알아볼 수 있습니다.\n\n검사는 약 15분 간 진행되며, 제시되는 문항을 보시고 자신에 해당하는 항목에 응답해주시면 됩니다. 문항은 지식, 역량, 흥미, 가치, 개인특성의 다섯 가지 분류로 구성되어 있으며, 응답 방식은 아래의 예시 문항을 참고하여 주시기 바랍니다.\n\n검사 중간에 나오실 경우 검사기록이 유실될 수 있으니 주의해주시기 바랍니다.\n\n아래의 "
          }
          <TextSpan fontSize={16} fontWeight="bold" color="var(--custom-blue)">
            {"검사 시작하기"}
          </TextSpan>
          {" 버튼을 누르시면 검사가 시작됩니다."}
        </TextDiv>
        <QuizItemSample />
      </DescriptionDiv>

      <StyledButton $size="large" onClick={() => setQuizPhase("preinfo")}>
        검사 시작하기
      </StyledButton>
    </>
  )
}

export default QuizIntro

const DescriptionDiv = styled.div`
  box-sizing: border-box;
  white-space: pre;
  border: 1px solid var(--custom-platinum);
  border-radius: 20px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`
